import { FC } from 'react';

import { useTaskPriorities } from '../hooks/useTaskPriorities';
import { Select, SelectProps } from '../uikit/Select';

export const SelectPriority: FC<SelectProps> = ({ ...props }) => {
  const { priorities } = useTaskPriorities();

  return <Select {...props} options={priorities} />;
};
